import { render, staticRenderFns } from "./OverallSalesByWeekNested.vue?vue&type=template&id=2d472965&scoped=true"
import script from "./OverallSalesByWeekNested.vue?vue&type=script&lang=js"
export * from "./OverallSalesByWeekNested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d472965",
  null
  
)

export default component.exports